import React, { useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Upload, Button } from "antd";
import request from "superagent";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { getAuthHeader } from "../../utils/superagent";
import { UpdateProfileUtils } from "./updateProfileUtils";
import { showErrorToast } from "@src/appV2/lib/Notifications";

const { Dragger } = Upload;
function UploadProfileImage({ agentId, closeModal, retrieveUser }) {
  const defaultCrop = {
    unit: "%",
    width: 60,
    aspect: 16 / 16,
    x: 20,
    y: 20,
  };
  const [file, setFile] = useState(null);
  const [crop, setCrop] = useState(defaultCrop);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [croppedImageFile, setCroppedImageFile] = useState<any>(null);
  const [imageRef, setImageRef] = useState(null);
  const [isLoading, setLoading] = useState(false);
  let initialCroppedImageRef = null;

  const onImageLoaded = (image) => {
    initialCroppedImageRef = image;
    setImageRef(image);
  };

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const onCropComplete = (crop) => {
    void makeClientCrop(crop);
  };

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow, @typescript-eslint/no-unused-vars
  const onCropChange = (crop, percentCrop) => {
    setCrop(percentCrop);
  };

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const makeClientCrop = async (crop) => {
    if (crop.width && crop.height) {
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const croppedImageFile = await getCroppedImage(
        imageRef || initialCroppedImageRef,
        crop,
        "newFile.jpeg"
      );
      setCroppedImageFile(croppedImageFile);
    }
  };

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const getCroppedImage = (image, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const canvasContext = canvas.getContext("2d");

    canvasContext?.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          showErrorToast("Please select area to crop image");
          return;
        }
        /**
         * FIXME - Refactor to set this readonly property correctly.
         */
        // @ts-expect-error Cannot assign to 'name' because it is a read-only property.ts(2540)
        blob.name = fileName;
        resolve(blob);
      }, "image/jpeg");
    });
  };

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const handlePreview = async (file) => {
    const previewFile = file;
    if (!file.url && !file.preview) {
      previewFile.preview = await getBase64(file);
    }

    setPreviewImageUrl(file.url || previewFile.preview);
  };

  const handleUpload = async () => {
    setLoading(true);

    const fssResponse = await UpdateProfileUtils.uploadProfilePicToFss(
      agentId,
      croppedImageFile,
      "jpeg"
    );

    const { fileStorageFileKey } = fssResponse;
    await request
      .put(`${global.api}/agentprofile/profilePic`)
      .set(await getAuthHeader())
      .send({
        agentId,
        profileImagefileStorageFileKey: fileStorageFileKey,
      });

    setLoading(false);
    retrieveUser();
    closeModal();
  };

  const handleChooseAnother = () => {
    setFile(null);
    setCrop(defaultCrop);
  };

  const props = {
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-shadow
    beforeUpload: (file) => {
      if (file.type.indexOf("/html") > -1) {
        showErrorToast("Use image files only (no .html or .htm)");
        return;
      }
      setFile(file);
      void handlePreview(file);
    },
    showUploadList: false,
  };

  return (
    <div>
      {!file && (
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">
            Support for a single upload. Strictly prohibit from uploading company data or other band
            files
          </p>
        </Dragger>
      )}
      {file && (
        <div style={{ textAlign: "center" }}>
          <p>Please select area to crop image</p>
          <ReactCrop
            src={previewImageUrl}
            crop={crop}
            ruleOfThirds
            keepSelection={true}
            minWidth={200}
            onImageLoaded={onImageLoaded}
            onComplete={onCropComplete}
            onChange={onCropChange}
          />
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <Button
              type="primary"
              style={{ margin: 5 }}
              disabled={isLoading}
              onClick={handleChooseAnother}
            >
              Choose Another Picture
            </Button>
            <Button type="primary" style={{ margin: 5 }} loading={isLoading} onClick={handleUpload}>
              Upload
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export { UploadProfileImage };
